export function getCountriesApi(currentUrl: string, fallbackUrl: string): string {
    try {
        const url = new URL(currentUrl);
        let host = url.hostname;

        if (host.startsWith("auth.")) {
            host = host.substring(5);
            return `${url.protocol}//${host}/api/countries`;
        }
    } catch (error) {
        console.error("Error parsing URL:", error);
    }

    return fallbackUrl;
}

export function getClientAgreementUrl(fallbackAgreementUrl: string): string {
    try {
        const currentUrl = new URL(window.location.href);

        if (currentUrl.hostname.startsWith("auth.")) {
            const mainDomain = currentUrl.hostname.substring(5);
            const agreementUrl = new URL(fallbackAgreementUrl);

            agreementUrl.hostname = mainDomain;
            return agreementUrl.toString();
        }
    } catch (error) {
        console.error("Failed to generate client agreement URL:", error);
    }

    return fallbackAgreementUrl;
}

export function getMyCapitalUrl(fallbackUrl: string): string {
    try {
        const currentUrl = new URL(window.location.href);

        if (currentUrl.hostname.startsWith("auth.")) {
            const mainDomain = currentUrl.hostname.substring(5);
            const mycapitalUrl = new URL(fallbackUrl);

            mycapitalUrl.hostname = mainDomain;
            return mycapitalUrl.toString();
        }
    } catch (error) {
        console.error("Failed to generate mycapital URL:", error);
    }

    return fallbackUrl;
}
